export default __webpack_public_path__ + "static/media/jason.810cc18f.png";